/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { css } from 'styled-components';
import { DEVICE_SIZES } from '../../theme/defaultTheme';

/* Тип <T> нужен чтобы симулировать поведение styled-compoonents v5 в v6 */
export const mobile600 = <T>(arg: any, ...args: any[]) => css`
    @media screen and (max-width: ${DEVICE_SIZES.mobile600.max}px) {
        ${css(arg, ...args)}
    }
`;

export const mobile = <T>(arg: any, ...args: any[]) => css`
    @media screen and (max-width: ${DEVICE_SIZES.mobile.max}px) {
        ${css(arg, ...args)}
    }
`;

export const tablet = <T>(arg: any, ...args: any[]) => css`
    @media screen and (min-width: ${DEVICE_SIZES.tablet.min}px) and (max-width: ${DEVICE_SIZES.tablet.max}px) {
        ${css(arg, ...args)}
    }
`;

export const tabletAndMobile = <T>(arg: any, ...args: any[]) => css`
    @media screen and (max-width: ${DEVICE_SIZES.tablet.max}px) {
        ${css(arg, ...args)}
    }
`;

export const desktop = <T>(arg: any, ...args: any[]) => css`
    @media screen and (min-width: ${DEVICE_SIZES.desktop.min}px) {
        ${css(arg, ...args)}
    }
`;

export const point488 = <T>(arg: any, ...args: any[]) => css`
    @media screen and (max-width: ${DEVICE_SIZES.point488.max}px) {
        ${css(arg, ...args)}
    }
`;

export const point488_792 = <T>(arg: any, ...args: any[]) => css`
    @media screen and (min-width: ${DEVICE_SIZES.point488_792.min}px) and (max-width: ${DEVICE_SIZES.point488_792
            .max}px) {
        ${css(arg, ...args)}
    }
`;

export const point792_1208 = <T>(arg: any, ...args: any[]) => css`
    @media screen and (min-width: ${DEVICE_SIZES.point792_1208.min}px) and (max-width: ${DEVICE_SIZES.point792_1208
            .max}px) {
        ${css(arg, ...args)}
    }
`;

export const point1208 = <T>(arg: any, ...args: any[]) => css`
    @media screen and (min-width: ${DEVICE_SIZES.point1208.min}px) {
        ${css(arg, ...args)}
    }
`;
